import pagerduty from 'src/lib/api/pagerduty';

export async function listAllIncidentWorkflowTriggersForServices(serviceIds, qs) {
  if (serviceIds.length === 1) {
    return listAllIncidentWorkflowTriggers({ ...qs, service_id: serviceIds[0] });
  } else {
    const result = await Promise.all(serviceIds.map(
      id => listAllIncidentWorkflowTriggers({ ...qs, service_id: id }))
    );
    const unique = [...new Map(result.flat().map(v => [v.id, v])).values()];
    return unique.sort((t1, t2) => t1.workflow_name.localeCompare(t2.workflow_name));
  }
}

export async function listAllIncidentWorkflowTriggers(qs) {
  let result = [];
  let cursor = undefined;
  while (true) {
    const { triggers, next_cursor } = await pagerduty.listIncidentWorkflowsTriggers({
      ...qs,
      cursor,
    });
    result.push(...triggers);
    if (!next_cursor) break;
    cursor = next_cursor;
  }
  return result;
}
